import { Injectable } from '@angular/core';
import { ServiceStock } from './service-stock.service';

import { io } from 'socket.io-client';
import { Observable, BehaviorSubject } from 'rxjs';
import { gotxModalComponent } from './gotxModal/gotxModal.component';

@Injectable({
  providedIn: 'root'
})
export class SocketioService {
  socket: any;
  socketId = '';
  totalAttempts = 0;
  totalReconnectAllowed = 0;
  private socketConnectedSubject: BehaviorSubject<boolean>;
  public socketConnected: Observable<boolean>;

  constructor(private services: ServiceStock) { 
    this.socketConnectedSubject = new BehaviorSubject<boolean>(false);
    this.socketConnected = this.socketConnectedSubject.asObservable();
  }

  public set setSocketConnectedValue(connected: boolean) {
    this.socketConnectedSubject.next(connected);
  }

  setupSocketConnection() {
    let nodeDetails = this.services.dataStore.getData("nodeDetails");

    //this.socket = io("http://" + nodeDetails.url + ":" + nodeDetails.port, {  // commetted for SSL
    this.socket = io(window.location.protocol + "//" + nodeDetails.url + ":" + nodeDetails.port, {
      path: nodeDetails.path,
      transports: ["websocket"],
      // rejectUnauthorized: false, 
      reconnection: true,
      reconnectionAttempts: nodeDetails.reAttempts,
      reconnectionDelay: nodeDetails.timeout
    });

    this.newConnections();
  }

  /*disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }*/

    disconnect() {
  if (this.socket && this.socket.connected) {
    this.socket.disconnect();
  }
  this.socket = null;
}

  listen(eventName: string) {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      })
    });
  }

  emit(eventName: string, data: any) {
    this.socket.emit(eventName, data);
  }

  newConnections() {
    // console.log("New Connections");
    this.listen('connect').subscribe(res => {
      console.log('[%s] Connected! : ', new Date(), this.socket.id);
      this.socketId = this.socket.id;
    });
    
    this.listen('connect_error').subscribe((error: any) => {
      console.log('[%s] connect_error! : ', new Date(), error);
      console.log("this.totalReconnectAllowed", this.totalReconnectAllowed);
      this.totalAttempts++;
      console.log("this.totalAttempts", this.totalAttempts);

      this.services.http.socketConnected = false;
      if (this.totalReconnectAllowed == this.totalAttempts) {
        this.services.http.hideSpinner();
        this.openModal();
      }
    });
    this.listen('connect_timeout').subscribe((error: any) => {
      console.log('[%s] connect_timeout! : ', new Date(), error);
      this.services.http.socketConnected = false;
    });

    this.listen('reconnect_failed').subscribe(() => {
      console.log('[%s] reconnect_failed! : ', new Date());
      this.services.http.socketConnected = false;
    });

    this.listen('reconnect_error').subscribe((error: any) => {
      console.log('[%s] reconnect_error! : ', new Date(), error);
      this.services.http.socketConnected = false;
    });

    this.listen('reconnecting').subscribe((error: any) => {
      console.log('[%s] reconnecting : ', new Date(), error);
      this.services.http.socketConnected = false;
    });

    this.listen('reconnect').subscribe((error: any) => {
      console.log('[%s] reconnect : ', new Date(), error);
      this.services.http.socketConnected = false;
    });

    this.listen('reconnect_attempt').subscribe((error: any) => {
      console.log('[%s] reconnect_attempt : ', new Date(), error);
      this.services.http.socketConnected = false;
    });

    this.listen('CONNECT_RSP').subscribe((data: any) => {
      console.log('[%s] CONNECT_RSP received ', new Date());
      console.log(this.socketId);
      this.emit('HTTP1.0', this.socketId);
    });

    this.listen('HTTP1.0').subscribe((data: any) => {
      console.log('[%s] In socket HTTP1.0 ', new Date());
      this.emit('HTTP1.1', this.socketId);
    });

    this.listen('HTTP1.1').subscribe((data: any) => {
      console.log('[%s] In socket HTTP1.1 ', new Date(), data);
      if (data == 'OK') {
        this.services.http.socketConnected = true;
        this.setSocketConnectedValue = true;
        this.services.http.hideSpinner();

        if (this.services.dataStore.subbedStocks.length > 0) {
          this.emit('MW.IWS.STOCKS.UNSUBS', JSON.stringify(this.services.dataStore.subbedStocks));
          this.emit('MW.IWS.STOCKS.SUBS', JSON.stringify(this.services.dataStore.subbedStocks));
        }
      }
    });
  }
  openModal() {
    let params = {
      title: 'Alert',
      message: 'Cannot connect to streaming server',
      buttons: ['OK'],
      buttonAction: ['logout'],
      buttonClass: ['btn btn-primary'],
      type: "Alert"
    }

    const modalRef = this.services.openModal(gotxModalComponent, 'sm', params, "Gotx Popup");
  }
}